export const PRODUCT_CATALOG_LIMIT = 2000;


